import { CloudOffRounded } from '@mui/icons-material';
import { Box, Typography } from '@mui/material';
import React from 'react';

export default function EmptyComponent() {
  return (
    <Box sx={{
      display: 'flex',
      alignItems: 'center',
      flexDirection: 'column',

    }}
    >
      <CloudOffRounded sx={{
        color: 'grey.500',
        height: '40px',
        width: '40px',
      }}
      />
      <Typography color="grey.500" align="center"> Empty data</Typography>
    </Box>
  );
}
